<template>
<div ref="scrollContainer" v-loading.fullscreen.lock="fullScreenLoading">
  <div>
    <div class="top-nav" style="margin-top:10px;">

      <span class="title">Gestion des utilisateurs</span>
      <div class="controls">
        <el-button @click="close();">{{$t('buttons.close')}}</el-button>
        <el-dropdown >
          <el-button type="primary">
            Actions<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item  @click.native="addNewUser"><i class="mdi mdi-account-plus"><span style="padding-left:5px;">Ajouter un nouvel utilisateur</span></i></el-dropdown-item>
            <el-dropdown-item :disabled="multipleSelection.length!=1" @click.native="editUser"><i class="mdi mdi-account-edit"><span style="padding-left:5px;">Modifier un utilisateur</span></i></el-dropdown-item>
          
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
  <div>
    <el-row>
      <el-card id="page-panel" class="pt-20">
        <el-table
          ref="multipleTable"
          :data="users"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :height="getHeight"
          :default-sort = "{prop: 'lastName', order: 'ascending'}">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            label="ID"
            width="50">
            <template slot-scope="scope"><el-button @click="clickUser(scope.row)" type="text" size="small">{{ scope.row.id }}</el-button></template>
          </el-table-column>
          <el-table-column
            property="firstName"
            label="Prénom"
            min-width="120"
            :show-overflow-tooltip="true"
            sortable>
          </el-table-column>
          <el-table-column
            property="lastName"
            label="Nom"
            min-width="120"
            :show-overflow-tooltip="true"
            sortable>
          </el-table-column>
          <el-table-column
            property="email"
            label="Courriel"
            min-width="200"
            :show-overflow-tooltip="true"
            sortable>
          </el-table-column>
          <el-table-column
            property="active"
            label="Actif"
            width="80"
            sortable>
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="getActiveString(scope.row)" placement="top">
                <i class="el-icon-success" v-if="scope.row.active"></i>
                <i class="el-icon-warning" v-else></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      
      </el-card>
    </el-row>
  </div>
  <userForm :userFormvisible="userFormVisible" @close="userFormVisible=false" @userCreated="userCreated" @userModified="userModified" :currentUser="currentUser"></userForm>
</div>
</template>
<script>
//import Section
import axios from "axios"
import userForm from '@/components/users/user-form-component'
import userService from '@/services/API/user'

export default {
  name: 'Users',
  data() {
    return {
      fullScreenLoading : true,
      users : [],
      multipleSelection : [],
      search : '',
      userFormVisible :false,
      currentUser : null,
      window: {
				width: 0,
				height: 0
			}
    };
  },
  components : {
    userForm : userForm
  },
  computed : {
    getHeight(){
			return (this.window.height-260);
		},
		getHeightStyle(){
			return "height:" + this.getHeight + "px;";
		}
  },
  methods : {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    close(){
			this.$router.go(-1);
		},
    getActiveString(user){
        return user.active?this.$t("user.active"):this.$t("user.inactive");
    },
    getAdminUsers(){
      return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/users?isAdmin=true")
        .then(response=>{
          return response.data;
        })
    },
    handleSelectionChange(val){
      this.multipleSelection = val
    },
    tableRowClassName({row, rowIndex}) {
      if (!row.active) {
        return 'warning-row';
      }
      return '';
    },
    archivedUser(){
      let currentUser = JSON.parse(localStorage.user);
      let userToArchive = this.multipleSelection[0];
      if(currentUser.id==userToArchive.id){
        this.$notify({
          title: "Archiver un utilisateur",
          message: "Il est impossible d'archiver l'utilisateur en cours.",
          type: 'error'
        });
      }else{
        userService.archiveUser(userToArchive.id)
          .then(()=>{
              this.$notify({
                title: "Archiver un utilisateur",
                message: "L'utilisateur a été archivé!",
                type: 'success'
              });
              this.getAdminUsers()
                .then(users=>{
                  this.users = users;
                  this.fullScreenLoading = false;
                })
          })
      }
    },
    deactivate(){
      let currentUser = JSON.parse(localStorage.user);
      this.fullScreenLoading=true;
      let postValue = [];
      _.forEach(this.multipleSelection, user=>{
        let tmp = {};
        tmp.id = user.id;
        tmp.active = false;
        if(tmp.id!=currentUser.id){
            postValue.push(tmp);
        }else{
          this.$notify({
            title: "Désactivation de l'utilisateur en cours!",
            message: "Il est impossible de désactiver l'utililisateur en cours.",
            type: 'warning'
          });
        }
      })
      if(postValue.length>0){
        userService.updateUser(postValue)
          .then(response=>{
            _.forEach(postValue, userSelected=>{
              var userTmp = _.find(this.users, user=>{
                return user.id==userSelected.id;
              })
              userTmp.active = false;
            })
            this.fullScreenLoading=false;
            this.$notify({
              title: "Désactivation",
              message: "Les utilisateurs sélectionnés ont été désactivés avec succès!",
              type: 'success'
            });
          })
      }else{
        this.fullScreenLoading=false;
      }

    },
    activate(){
      this.fullScreenLoading=true;
      let postValue = [];
      _.forEach(this.multipleSelection, user=>{
        let tmp = {};
        tmp.id = user.id;
        tmp.active = true;
        postValue.push(tmp);
      })
      userService.updateUser(postValue)
        .then(response=>{
          _.forEach(this.multipleSelection, userSelected=>{
            var userTmp = _.find(this.users, user=>{
              return user.id==userSelected.id;
            })
            userTmp.active = true;
          })
          this.fullScreenLoading=false;
          this.$notify({
            title: "Activation",
            message: "Les utilisateurs sélectionnés ont été activés avec succès!",
            type: 'success'
          });
        })
    },
    addNewUser(){
      this.currentUser=null;
      this.userFormVisible=true;
    },
    userCreated(user){
      this.$notify({
        title: "Nouvel utilisateur",
        message: "L'utilisateur a été créé avec succès!",
        type: 'success'
      });
      this.getAdminUsers()
        .then(users=>{
          this.users = users;
          this.fullScreenLoading = false;
        })
    },
    editUser(){
      this.currentUser = this.multipleSelection[0];
      this.userFormVisible=true;
    },
    clickUser(user){
      this.currentUser = user;
      this.userFormVisible=true;
    },
    userModified(user){
      this.$notify({
        title: "modification utilisateur",
        message: "L'utilisateur a été modifié avec succès!",
        type: 'success'
      });
      this.getAdminUsers()
        .then(users=>{
          this.users = users;
          this.fullScreenLoading = false;
        })
    },
  },
  mouted(){

  },
  created(){
    this.getAdminUsers()
      .then(users=>{
        this.users = users;
        this.fullScreenLoading = false;
      })
    window.addEventListener('resize', this.handleResize)
    this.handleResize();

  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.top-nav{
 height:100px;
}

.title {
  font-size : 1.8em;
  font-weight:bold;
  margin-right:10px;
  margin-left:10px;
  position:relative;
  float:left;
}



.controls{
	position:relative;
	float:right;
	button{
		margin-left:20px;
	}
}

.el-table .warning-row {
    background: oldLace;
}

.el-table__body-wrapper {
  max-height:800px;
}


</style>
